import '../jquery'

let ready_legacy_user_contacts;

ready_legacy_user_contacts = function () {
  $("body .domain_contact_country").change(function () {
    if ($('#domain_contact_country').selectpicker('val') === "LV" && $("input[name='domain_contact[person_type]']:checked", "#new_domain_contact").val() === "private_person") {
      return $(".domain_contact_identity_number").show();
    } else {
      $(".domain_contact_identity_number").hide();
      return $("#domain_contact_identity_number").val("");
    }
  });
  return $('body').on('change', '.domain_contact_person_type input', function () {
    return $.post("/domains/domain_contacts/change_type", $('#new_domain_contact').serialize());
  });
};

//  $("#domain_registrant_id").change ->
//    $.post "/domains/domains/edit/select-registrant", {
//      id: $(this).data("domain-id")
//      domain_contact_id: $(this).val()
//    }, (res) ->
//      console.log(res)
//    return
$(document).ready(ready_legacy_user_contacts);

$(document).on('turbo:load', ready_legacy_user_contacts);